import React from 'react'

import { bool, number, string } from 'prop-types'

const IMAGE_WIDTH = 1080
const IMAGE_HEIGHT = 617

function Card({
  href,
  heading,
  imageSrc = '',
  imageWidth = IMAGE_WIDTH,
  imageHeight = IMAGE_HEIGHT,
  eager = false,
}) {
  return (
    <a className="ai-generator-hub__card" href={href}>
      {imageSrc && (
        <img
          className="ai-generator-hub__card-image"
          src={imageSrc}
          alt=""
          width={imageWidth}
          height={imageHeight}
          style={{ aspectRatio: `${imageWidth} / ${imageHeight}` }}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
        />
      )}
      <h2 className="ai-generator-hub__card-title cgt-heading-300">{heading}</h2>
    </a>
  )
}

Card.propTypes = {
  href: string.isRequired,
  heading: string.isRequired,
  imageSrc: string,
  imageWidth: number,
  imageHeight: number,
  eager: bool,
}

export default Card
